
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import _ from "lodash-es";
import SetScore from "./step-view/set-score.vue";
import SetQuestion from "./step-view/set-question.vue";
import SetDimension from "./step-view/set-dimension.vue";
import SetTest from "./step-view/set-test.vue";
import SetOther from "./step-view/set-other.vue";
import AskGoOn from "./components/delete-dialog.vue";
import vuexStore from "@/store/vuex-store";
import {
  BeforeVideo,
  ExamV2Custom,
  StructExamScoreConfig,
  StructExamQuestionCommentConfig,
  StructExamDimensionConfig,
  StructExamQuestionConfig,
  Vir
} from "@/lib/model/exambuilder/exam-v2";
import Auth from "@/lib/common/auth";
import ExamList from "@/lib/model/exam/exam";
import { ExamGetForm } from "@/lib/form/exam/ExamListForm";
import MsgRequest from "@/lib/model/message/MsgRequest";
import Power from "@/views/paper/components/power.vue";
import AiStepBar from "@/components/layout/ai-builder-step.vue";
import PositionList, {
  Industry,
  Position,
  PositionIndustryList,
  Template as TemplateNew
} from "@/lib/position/position";
import {
  StructConfigGroup,
  StructDimensionGroupConfig
} from "@/lib/model/exambuilder/configGroup";
import Config from "./config/config.vue";

@Component({
  components: {
    SetScore,
    SetQuestion,
    SetDimension,
    SetOther,
    SetTest,
    AskGoOn,
    Power,
    AiStepBar,
    Config
  }
})
export default class AiBuilder extends Vue {
  pathText = "新建面试";
  stepShow: boolean[] = [false, false, false, false, false]; //五个步骤显隐
  currentStep = 0; //当前步骤 0 1 2 3 4
  vuexStores = vuexStore;
  examGetForm = new ExamGetForm();
  paperId = 0;
  isEdit = false; //是否编辑页面
  dataInited = false;
  askGoOn = false; //是否继续上次的新建流程
  isCandidateUsed = false; //是否有候选人答题
  powerExamId = 0; //设置权限的面试id
  showPower = false;
  templateNew = new TemplateNew(); //新模板
  positionIndustryList = new PositionIndustryList();
  virList: Vir[] = []; //虚拟人列表

  // 翻页限制速度，防止点击太快
  canChangePage = true;
  canCancelPage = true;
  pageInterval = 300;
  cancelInterval = 500;
  submiting = false;

  // 原始分数配置，如果有候选人答完题，则需要使用原始分数配置提交
  originScoreConfigList: StructExamScoreConfig[] | null = null;

  videoUrlDef =
    "https://vod.hina.com/a3309d04251940faa56806be59bdf122/8c7be05066f64d29ae74ffbd5500daa9-ca173c7e0f3241eb8285dedda051a1ba-ld.mp4"; //视频预览url默认
  descImgUrlDef =
    "https://oss.hina.com/app/hina/2021/07/10/3f1396a2ddd6a8493c582f22c69dae39.png"; //须知语默认封面

  // 保存定时器，避免频繁写入数据
  saveDataTimer: number | null = null;

  exam: ExamV2Custom = new ExamV2Custom();
  askSubmit = false; //完成弹窗
  askCancel = false; //完成弹窗
  ask = {
    title: "",
    text: "",
    cancelBtn: "",
    okBtn: ""
  };

  companyPower = {}; //公司一些权限
  fromTemplateStoreId = ""; //模板库带入id

  //内部使用 设置web页
  get setWeb(): boolean {
    return this.$route?.query?.teamUse === "setWeb";
  }

  //已有候选人 直接弹到第三步
  @Watch("isCandidateUsed")
  save(n: any, o: any) {
    if (n && this.currentStep < 2) {
      this.showCurrentStep(2);
    }
  }
  @Watch("exam.dimensionKeyList", { deep: true, immediate: true })
  onChange() {
    this.exam.examDimensionConfigList = this.exam.dimensionKeyList.reduce(
      (dimenConfigList, dimenKey) => {
        const dimen = this.exam.examDimensionConfigList.find(
          dimensionConfig => dimensionConfig.dimensionKey === dimenKey
        );
        if (dimen) {
          dimenConfigList.push(dimen);
        } else {
          dimenConfigList.push(new StructExamDimensionConfig(dimenKey));
        }
        return dimenConfigList;
      },
      [] as StructExamDimensionConfig[]
    );
  }

  //禁用上一步  已有候选人 不得进入1 2步。  r2追加：抽题组卷 不得进入 12步
  get disabledPre() {
    const r1 = this.isEdit && this.isCandidateUsed && this.currentStep === 2;
    // const r2 =
    //   this.isEdit &&
    //   this.exam.isRandomQuestions === 1 &&
    //   this.currentStep === 2;
    return r1;
  }

  async created() {
    this.loadCache();
    this.getPosition();
    this.virList = await Vir.getList();

    this.dataInited = false;
    this.currentStep = 0;
    if (this.$route?.query?.templateId) {
      //模板 进入
      this.newCreate();
      this.fromTemplateStoreId = this.$route?.query?.templateId as string;
      await this.setTemplate();
      this.dataInited = true;
    } else {
      if (Number(this.$route?.query?.paperId)) {
        //编辑进入
        this.paperId = Number(this.$route.query.paperId);
        this.examGetForm.examId = Number(this.paperId);
        this.examGetForm.companyId = Number(Auth.companyId);
        this.currentStep = Number(this.$route?.query?.step ?? 0);
        this.isEdit = true;
        this.pathText = "编辑面试";
        this.getExam();
      } else {
        // 新建进入  -有缓存 询问是否继续新建
        if (localStorage.getItem("aibuildercachev1")) {
          this.askGoOn = true;
        } else {
          //-无缓存  初始化
          this.newCreate();
        }
        this.dataInited = true;
      }
    }
    //进入url指定对应页面 默认0
    this.showCurrentStep(this.currentStep);
    this.vuexStores.updateAiStep({ show: true, step: this.currentStep });
    this.getCompanyPower();
  }
  //获取面试信息
  async getExam(getInfo = true) {
    const res = await ExamList.examGetAi(this.examGetForm);
    if (getInfo) {
      this.exam = new ExamV2Custom().assign(res);
      this.exam.setDefaultValue();
      this.originScoreConfigList = this.exam.examScoreConfigList;
      this.pathText = "编辑面试-" + this.exam.name;
    }
    // 如果url上带有forceUpdate=1，则无视候选人存在强制更新面试
    const forceUpdate = Number(this.$route.query.forceUpdate) == 1;
    this.isCandidateUsed = this.exam.isCandidateUsed === 1 && !forceUpdate;
    this.dataInited = true;
  }
  //公司权限
  getCompanyPower() {
    MsgRequest.getCompanyInfo(parseInt(Auth.companyId)).then((res: any) => {
      if (res.code === 0) {
        this.companyPower = res.data.companySpecialConfig;
      }
    });
  }

  //步骤控制
  showCurrentStep(index: number) {
    this.currentStep = index;
    this.vuexStores.updateAiStep({ show: true, step: index });
    //刷新保持当前页面 -更新url
    const urlParams = this.$route.query;
    if (!urlParams?.step) {
      //url加step
      window.history.pushState(
        "",
        "",
        this.$route.fullPath + "&step=" + this.currentStep
      );
    } else {
      //url更新step
      urlParams.step = String(this.currentStep);
      let p = ``;
      for (const i in urlParams) {
        p += `${i}=${urlParams[i]}&`;
      }
      window.history.pushState(
        "",
        "",
        this.$route.path + "?" + p.substring(0, p.length - 1)
      );
    }
    this.stepShow.forEach((item: boolean, i: number) => {
      if (index === i) {
        this.$set(this.stepShow, i, true);
      } else {
        this.$set(this.stepShow, i, false);
      }
    });
  }
  //取消
  cancel() {
    if (!this.canChangePage) return;

    this.ask = {
      title: `确定要离开吗？`,
      text: `
           系统将不会保存任何${this.isEdit ? "编辑" : "创建"}面试配置，请确认`,
      cancelBtn: "取消",
      okBtn: "确认"
    };

    this.askCancel = true;
  }

  checkHasCandidateUsed() {
    // 已有候选人答题时不可更改分数
    if (this.exam.isCandidateUsed && this.originScoreConfigList) {
      this.exam.examScoreConfigList = this.originScoreConfigList;
    }
  }
  get forceEdit(): boolean {
    return Boolean(this.$route?.query?.forceEdit) || false;
  }
  //完成
  async submit() {
    //如果编辑面试未改变任何配置 则不走接口 伪装提交成功 先测试个把月 再上线
    if (Boolean(0) && this.isEdit && !this.forceEdit) {
      const notChangeExam = this.exam.compareWithDefaultValue((model: any) => {
        //对比前 删掉多余的字段，处理一下前后端字段 同义不同值 的字段
        delete model._defaultValue;
        model.timeLimitExam =
          model.timeLimitExam === 0
            ? 86400
            : this.isEdit
            ? model.timeLimitExam * 60
            : model.timeLimitExam;
      });
      if (notChangeExam) {
        this.showAskPower(this.exam.examId);
        return;
      }
    }
    this.exam.delete_defaultValue();
    //一些前置校验
    this.checkHasCandidateUsed();
    console.log(this.exam);
    const dataOK = await (this.$refs["step5"] as any)?.checkData();
    if (!dataOK) {
      return;
    }
    if (this.submiting) return;
    this.submiting = true;
    // 开始loading
    (this.$refs.step5 as any)?.startLoading();
    this.exam.examId = this.paperId;
    //视频默认特判
    this.exam.publicityPageVideoUrl =
      this.exam.publicityPageVideoUseWhich === 1
        ? this.videoUrlDef
        : this.exam.publicityPageVideoUrl;
    //须知语封面默认特判
    if (this.exam.descAfterShowWay === 1) {
      this.exam.descAfterShowWayImgUrl = this.descImgUrlDef;
    }
    //分转秒
    this.exam.timeLimitExam = this.exam.timeLimitExam * 60;

    //过滤富文本figure标签本身 (页面loading中 富文本编译器已销毁 不影响结果)
    this.exam.publicityPageContent = this.exam.publicityPageContent
      .replace(/<figure[^>]*>/g, "")
      .replace(/<\/figure>/g, "");

    this.exam.examVideoList.forEach((it: BeforeVideo) => {
      it.text = it.text
        .replace(/<figure[^>]*>/g, "")
        .replace(/<\/figure>/g, "");
    });

    // 处理评价规则
    this.exam.examQuestionConfigList = this.exam.examQuestionConfigList.reduce(
      (
        pre: StructExamQuestionConfig[],
        questionConfig: StructExamQuestionConfig
      ) => {
        if (questionConfig.questionId) {
          questionConfig.commentConfigList = questionConfig.commentConfigList.reduce(
            (pre, cur) => {
              if (cur.comment.length) {
                pre.push(cur);
              }
              return pre;
            },
            [] as StructExamQuestionCommentConfig[]
          );
          pre.push(questionConfig);
        }
        return pre;
      },
      [] as StructExamQuestionConfig[]
    );
    // 处理追问配置
    this.exam.examDimensionConfigList = this.exam.examDimensionConfigList.reduce(
      (pre, dimension) => {
        if (dimension.dimensionKey) {
          pre.push(dimension);
        }
        return pre;
      },
      [] as StructExamDimensionConfig[]
    );
    this.exam.dimensionGroupConfigList = this.exam.dimensionGroupConfigList.reduce(
      (pre, cur: StructDimensionGroupConfig) => {
        if (cur.groupName) {
          pre.push(cur);
        }
        return pre;
      },
      [] as StructDimensionGroupConfig[]
    );
    console.log(this.exam);
    // 如果url上带有forceUpdate=1，则无视候选人存在强制更新面试
    const forceUpdate = Number(this.$route.query.forceUpdate) == 1;
    ExamV2Custom[this.isEdit ? "update" : "create"](this.exam, forceUpdate)
      .then(
        res => {
          if (res.data.code === 0) {
            this.showAskPower(res.data.data.examId);
          } else {
            //
          }
        },
        () => {
          //报错后 返回
          this.submitErrorHandler();
          (this.$refs.step5 as any)?.endLoading();
        }
      )
      .finally(() => {
        this.submiting = false;
      });
  }
  // 报错后返回的处理，还原保存的时候的一些处理
  submitErrorHandler() {
    // 答题时间限制那里做了处理（452 行），分转秒。这里报错了，要秒转分，还原回去。
    if (this.exam.timeLimitExamType === 2 && this.exam.timeLimitExam) {
      this.exam.timeLimitExam = this.exam.timeLimitExam / 60;
    }
  }
  //询问是否编辑权限
  showAskPower(examId: number) {
    this.ask = {
      title: `${this.isEdit ? "编辑" : "保存"}成功`,
      text: `面试已${
        this.isEdit ? "编辑" : "保存"
      }成功，系统生成题目视频、面试引导视频等需要一定时间，请等待5分钟后扫码参加面试`,
      okBtn: "设置管理权限",
      cancelBtn: "返回面试列表"
    };
    this.powerExamId = examId;
    this.askSubmit = true;
    if (!this.isEdit) {
      //新建后 清掉缓存
      this.clearCache();
    }
  }
  //面试权限弹窗
  toPower() {
    //
    this.showPower = true;
  }
  //上一步
  pre() {
    if (!this.canChangePage) return;
    this.beforePageChange();
    if (this.currentStep === 0) {
      //todo 进行对应页面离开前的数据校验
    }
    if (this.currentStep === 1) {
      //todo 进行对应页面离开前的数据校验
    }
    if (this.currentStep === 2) {
      //todo 进行对应页面离开前的数据校验
    }
    if (this.currentStep === 3) {
      //todo 进行对应页面离开前的数据校验
    }
    if (this.currentStep === 4) {
      //todo 进行对应页面离开前的数据校验
      //限制时间 转化
      if (this.isEdit && this.exam.timeLimitExamType === 2) {
        this.exam.timeLimitExam = this.exam.timeLimitExam * 60;
      }
      // this.exam.timeLimitExam =
      //   this.exam.timeLimitExam === 0 ? 86400 : this.exam.timeLimitExam * 60; //秒转分
    }
    this.showCurrentStep(this.currentStep - 1);
    if (this.isEdit) {
      this.getExam(false); //获取是否有人答题
    }
  }
  //下一步
  async next() {
    console.log(this.exam);
    if (!this.canChangePage) return;
    this.beforePageChange();
    const checkDataResult = (this.$refs[
      "step" + (this.currentStep + 1)
    ] as any)?.checkData();
    console.log(checkDataResult);
    if (!checkDataResult) return;
    this._next();
    if (this.isEdit) {
      await this.getExam(false); //获取是否有人答题
      this.checkHasCandidateUsed();
    }
  }
  // 防止点太快
  beforePageChange() {
    this.canChangePage = false;
    this.canCancelPage = false;
    setTimeout(() => {
      this.canChangePage = true;
    }, this.pageInterval);
    setTimeout(() => {
      this.canCancelPage = true;
    }, this.cancelInterval);
  }

  // 不检查直接下一步
  _next() {
    this.showCurrentStep(this.currentStep + 1);
  }
  back() {
    this.clearCache();
    this.$router.push("/exam/paper");
  }
  destroyed() {
    console.log("离开");
    this.vuexStores.updateAiStep({ show: false, step: 0 });
  }
  getInfo(info: any, type?: string) {
    let temp: any;
    if (type === "tag") {
      temp =
        this.exam.applicationRuleList?.filter(
          (el: any) => el.type === "级联面试分配"
        ) || [];
      temp.push(...info);
    } else {
      // 集联
      temp =
        this.exam.applicationRuleList?.filter(
          (el: any) => el.type !== "级联面试分配"
        ) || [];
      temp.push(...info);
    }
    this.exam.applicationRuleList = temp;
    console.log(this.exam.applicationRuleList);
    // if (this.exam.applicationRuleList && Array.isArray(this.exam.applicationRuleList)) {
    //   for (let i = 0; i < this.exam.applicationRuleList.length; i++) {
    //     const el = this.exam.applicationRuleList[i];
    //     for (let j = 0; j < info.length; j++) {
    //       const item = info[j];
    //       if (el.applicationRuleId === item.applicationRuleId)
    //     }
    //   }
    // } else {
    //   this.exam.applicationRuleList = info;
    // }
  }
  // 保存缓存
  saveCache() {
    if (this.isEdit) {
      // 编辑面试不需要保存缓存
      return;
    }
    if (this.submiting) return;

    console.log(this.exam);
    //延迟缓存，以免自动分配分数时频繁IO
    if (this.saveDataTimer) clearTimeout(this.saveDataTimer);
    this.saveDataTimer = setTimeout(() => {
      this.saveDataTimer = null;
      localStorage.setItem("aibuildercachev1", JSON.stringify(this.exam));
    }, 500);
  }

  loadCache() {
    const cacheJson = localStorage.getItem("aibuildercachev1");
    if (cacheJson) this.exam = new ExamV2Custom().assign(JSON.parse(cacheJson));
    // console.log("读取缓存", this.exam);
  }

  clearCache() {
    localStorage.removeItem("aibuildercachev1");
  }
  goOn() {
    this.askGoOn = false;
  }
  //重新创建
  newCreate() {
    this.clearCache();
    this.exam = new ExamV2Custom();
    //字段初始化
    this.exam.examVideoList = [];
    this.exam.colorConfig.type = 2;
    this.$set(this.stepShow, 0, false);
    this.$nextTick(() => {
      this.$set(this.stepShow, 0, true);
    });
    this.askGoOn = false;
  }

  // 创建后提示弹窗
  submitOk() {
    this.$router.push("/exam/paper");
  }
  //取消后提示弹窗
  cancelOk() {
    if (!this.isEdit) {
      //新建 取消会清缓存
      this.clearCache();
    } else {
      //编辑 本身就无缓存
    }
    this.$router.push("/exam/paper");
  }
  //选中模板
  selectTemp(t: ExamV2Custom) {
    const n = this.exam.name;
    console.log(new ExamV2Custom());
    console.log(t);
    console.log(this.exam);
    this.exam = t;
    this.exam.name = n;
    this.saveCache();
  }

  //岗位模板 新
  async setTemplate() {
    const p = {
      templateId: this.fromTemplateStoreId
    };
    return await PositionList.getTemplateList(p).then((res: any) => {
      if (res.list.length) {
        this.templateNew = new TemplateNew().assign(res.list[0]);
        this.exam = this.templateNew.assignIntoExamV2();
        // this.assignTemplateNew();
      } else {
        this.$message.warning("模板不存在");
      }
    });
  }
  //拉行业和岗位
  getPosition() {
    PositionList.get().then((res: PositionIndustryList) => {
      this.positionIndustryList = res;
    });
  }
}
